const development = {
  REACT_APP_AWS_PROJECT_REGION: 'us-east-1',
  REACT_APP_AWS_COGNITO_REGION: 'us-east-1',
  REACT_APP_AWS_USER_POOLS_ID: 'us-east-1_JQlkrS0Dz',
  REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID: '2p8ld1alsptqkpuv2fe9oeateo',
  REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID: 'us-east-1:2f4d76ba-2016-471c-9195-b5ef23258ccf',
  REACT_APP_IS_ONBOARDING_ENABLED: true,
  REACT_APP_PUSHER_APP_KEY: '8d048af3a1e02595ed8c',
  REACT_APP_API_URL: 'https://api.boxes-dev.link',
  REACT_APP_PUSHER_AUTH_ENDPOINT: 'https://api.boxes-dev.link/notifications/subscribe',
  REACT_APP_PUSHER_CLUSTER: 'mt1',
  REACT_APP_STRIPE_PK: 'pk_test_51Jm8LVCwtypmaWX0ydn5fmpX0HPwx3ZgeoHytj9ycxGdKyE8EGAO2gLc9LulHPFuw8xPzZAikLcYUdBaXz5NpQgd006FthSDEb',
}

const staging = {
  REACT_APP_AWS_PROJECT_REGION: 'us-east-1',
  REACT_APP_AWS_COGNITO_REGION: 'us-east-1',
  REACT_APP_AWS_USER_POOLS_ID: 'us-east-1_bCFaFdfLV',
  REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID: 'itt06253abjrrv8o49nm6slm6',
  REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID: 'us-east-1:c262d39a-3f02-4d29-8c76-64a85a00baa6',
  REACT_APP_PUSHER_APP_KEY: 'e093e44014dbd854fc66',
  REACT_APP_MEDIA_API_URL: 'https://media.boxes.im',
  REACT_APP_PUSHER_AUTH_ENDPOINT: 'https://api.boxes.im/notifications/subscribe',
  REACT_APP_PUSHER_CLUSTER: 'mt1',
  REACT_APP_API_URL: 'https://api.boxes.im',
  REACT_APP_DOMAIN_NAME: 'boxes.im',
  REACT_APP_FLAGS_ENABLED: 1,
  REACT_APP_STRIPE_TEST_PK: 'pk_test_51Jm8LVCwtypmaWX0ydn5fmpX0HPwx3ZgeoHytj9ycxGdKyE8EGAO2gLc9LulHPFuw8xPzZAikLcYUdBaXz5NpQgd006FthSDEb',
  REACT_APP_STRIPE_LIVE_PK: 'pk_live_51Jm8LVCwtypmaWX05hA0Dz4BMdbgqKabcFj5W30pQ3atIJShpmDgdUMdwFrQOTZM6mrh5gsGS3YEMUqGM7U4E7hO00uCqxUBgg',
  REACT_APP_IS_ONBOARDING_ENABLED: true,
}

module.exports = {
  dev: development,
  stg: staging,
}
